import {CSSProperties} from "react";

export const longTextStyles: CSSProperties = {
    margin: 0,
    whiteSpace: "pre-wrap",
    textJustify: 'inter-word',
    textAlign: 'justify',
    textIndent: '1rem',
};